
export default {
  socketUrl: process.env.REACT_APP_API,
  baseUrl: `${process.env.REACT_APP_API}/api/v1/`,
  imageUrl:"https://chatwork-messenger.s3.ap-south-1.amazonaws.com/media/"
};
